module.exports = __webpack_public_path__ + "img/Expo-Journals-Coming-soon.d05bd0eb.png";